// extracted by mini-css-extract-plugin
module.exports = {"logo":"_1F9iqD7rf_n2t0PjrV3p66","title":"_3BGuya25B5_WZX0L7cApOL","focused":"_1jFSzHM9rWCYHEWSbtPvJa","logoImage":"_2xXQT62kcRdTq2UUEgWH1t"};